import { Link } from 'react-router-dom';
import { resourceStats } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="px-4 md:px-6 py-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">
              VigorBuy <span className="text-primary-400">Spreadsheet</span>
            </h3>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Your complete resource hub for spreadsheet management. 
              Explore guides, templates, comparisons, and tutorials to master 
              data organization and boost productivity.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Main Website
              <i className="ri-external-link-line"></i>
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Resources</h4>
            <div className="flex flex-wrap gap-4">
              {resourceStats.map((stat) => (
                <div key={stat.label} className="bg-white/10 rounded-lg px-4 py-3 text-center min-w-[100px]">
                  <div className="text-xl font-bold text-primary-400">{stat.count}</div>
                  <div className="text-xs text-white/50 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog/what-is-vigorbuy-spreadsheet-complete-guide" className="text-sm text-white/60 hover:text-white transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors">
                  Main Store
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet Resources. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/40 text-xs hover:text-white/70 transition-colors">
              Privacy Policy
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/40 text-xs hover:text-white/70 transition-colors">
              Terms of Service
            </a>
            <Link to="/" className="text-white/40 text-xs hover:text-white/70 transition-colors">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}